/* eslint-disable import/no-named-as-default */
import api from './base.service';

export const getLocations = () => {
    return api().get('/api/locations/scheduled');
};
